import instance from "../../../config/axios";
import url from "../../../constants/url";
import type {CreateVendorDetailsResponse } from "./types";
export { getEntityList } from "../BlendSheet/service";
export { getItemTypeListData } from "../GreenCoffee/Services";

const vendor = "vendor";
const grid = "dispatch-grid-list";
const dispatch = "dispatch";
const vehicles = "vehicles";
const vehicleTrips = "vehicle-trips";
const suppliersList= "supplier-list";
const itemList= "item-list";
const poList= "po-list";
const create = "create";

export const getDispatchInfoListApi = async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${grid}`, payload)
    .then((res) => {
      return res;
    });
};

export const getVehicleInfoList = async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${dispatch}/${vehicles}`, payload)
    .then((res) => res);
};

export const getVehicleTripList = async (record_id: string | number) => {
  return instance
    .get(`${url.packagingapiurl}${vendor}/${vehicleTrips}/${record_id}`)
    .then((res) => res);
};

export const getSuppliersList = async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${suppliersList}`, payload)
    .then((res) => res);
};
export const getItemList = async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${itemList}`, payload)
    .then((res) => res);
};
export const getPOList = async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${poList}`, payload)
    .then((res) => res);
};

export const createVendorDetails =  async (payload: Record<string, unknown>) => {
  return instance
    .post(`${url.packagingapiurl}${vendor}/${create}`, payload)
    .then((res: any): CreateVendorDetailsResponse => res);
};